export const downloadBlob = async (blob: Blob, filename: string): Promise<void> => {
  // Feature detection for File System Access API
  const supportsFileSystemAccess =
    'showSaveFilePicker' in window &&
    (() => {
      try {
        return window.self === window.top
      } catch {
        return false
      }
    })()

  // Modern approach: File System Access API
  if (supportsFileSystemAccess) {
    try {
      const handle = await (window as any).showSaveFilePicker({
        suggestedName: filename
      })
      const writable = await handle.createWritable()
      await writable.write(blob)
      await writable.close()
      return
    } catch (err: any) {
      // Fail silently if user canceled the dialog
      if (err.name !== 'AbortError') {
        console.error('File System Access API failed:', err.name, err.message)
      }
      // Fall through to legacy method
    }
  }

  // Legacy fallback for older browsers
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()

  // Cleanup with delay to ensure download starts
  setTimeout(() => {
    URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }, 1000)
}

export const generatePDFFilename = (configurationId: number): string => {
  const date = new Date().toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
  return `Relaxtrailer-Konfiguration-${configurationId}-${date}.pdf`
}
